import { Factory } from "@/repository/Factory";
const AdminUser = Factory.get("adminUser");

const state = {
  adminUsers: []
};

const getters = {
  getAdminUsers: state => state.adminUsers
};

const mutations = {
  setAdminUsers: (state, payload) => {
    state.adminUsers = payload.map(user => {
      return {
        ...user,
        name: user.first_name + " " + user.last_name
      };
    });
  }
};

const actions = {
  // Get Admin Users
  async getAdminUsers({ commit }, payload) {
    commit("setAdminUsers", []);

    return await AdminUser.getAdminUsers(payload).then(
      response => {
        if (response.status === 200) {
          commit("setAdminUsers", response.data);

          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Update Admin User
  async updateAdminUser({ commit }, payload) {
    return await AdminUser.updateAdminUser(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          commit(
            "setToast",
            {
              message: response.data.message || "Admin updated successfully",
              type: "success",
              show: true
            },
            { root: true }
          );
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Delete Admin
  async deleteAdminUser({ commit }, payload) {
    return await AdminUser.deleteAdminUser(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          commit(
            "setToast",
            {
              message: response.data.message || "Admin deleted successfully",
              type: "success",
              show: true
            },
            { root: true }
          );
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Invite Admin
  async inviteAdmin({ commit }, payload) {
    return await AdminUser.inviteAdmin(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          commit(
            "setToast",
            {
              message: response.data.message,
              type: "success",
              show: true
            },
            { root: true }
          );

          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        return Promise.reject(message);
      }
    );
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
